const DoYouWantTheNewLockToWorkWithAnExistingKey = {
  tip: 'WiFi and digital set up is not included in the installation price.'
};
export const questionsExtraData = {
  650: DoYouWantTheNewLockToWorkWithAnExistingKey
};
